/* Treuespur final conversion fixes – 2026-09-02 */
(function () {
  'use strict';

  var BACK_ADDON_VARIANT = 55160152064337;
  var backPriceNode = document.querySelector('[data-ts-back-price]');
  var BACK_PRICE = backPriceNode ? '+' + JSON.parse(backPriceNode.textContent) : 'Price shown in cart';
  var BACK_FIELD = 'properties[_treuespur_back_engravings]';
  var ELIGIBLE_BACK_ENGRAVING = [
    'regenbogenbruecke-kette-tierportraet',
    'tierportraet-kette-foto-name',
    'tierportraet-schluesselanhaenger-foto',
    'tierportraet-armband-foto-name',
    'herzkette-tierportraet-name',
    'paperclip-kette-tierportraet',
    'tag-kette-tierportraet-name',
    'paperclip-armband-tierportraet',
    'silhouetten-armband-tierfoto',
    'herzarmband-tierfoto-name',
    'silhouetten-schluesselanhaenger-tierfoto',
    'schluesselanhaenger-tierportraet-name'
  ];

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function currentHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return '';
    var aliases = {'personalized-pet-portrait-necklace':'tierportraet-kette-foto-name','personalized-pet-portrait-keychain':'tierportraet-schluesselanhaenger-foto','personalized-pet-portrait-bracelet':'tierportraet-armband-foto-name','close-to-my-heart-pet-necklace':'herzkette-tierportraet-name','heartline-pet-portrait-paperclip-necklace':'paperclip-kette-tierportraet','everyday-keepsake-dog-tag-necklace':'tag-kette-tierportraet-name','heartline-pet-portrait-paperclip-bracelet':'paperclip-armband-tierportraet','one-of-a-kind-pet-silhouette-bracelet':'silhouetten-armband-tierfoto','forever-in-my-heart-pet-bracelet':'herzarmband-tierfoto-name','one-of-a-kind-pet-silhouette-keychain':'silhouetten-schluesselanhaenger-tierfoto','everyday-companion-pet-keychain':'schluesselanhaenger-tierportraet-name'};
    return aliases[match[1]] || match[1];
  }

  function replaceTextNodes(root, replacements) {
    if (!root || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue || '';
      var next = value;
      replacements.forEach(function (pair) {
        if (next.indexOf(pair[0]) !== -1) next = next.split(pair[0]).join(pair[1]);
      });
      if (next !== value) node.nodeValue = next;
    }
  }

  function normalizeAnnouncements() {
    var root = document.querySelector('#header-group') || document.querySelector('header');
    replaceTextNodes(root, [
      ['4,8/5', '4,9/5'],
      ['Von Tierfreunden geliebt', 'Based on real customer reviews'],
      ['1–2 WT Bestellannahme · 1–3 WT Produktion · 5–7 WT Versand', 'Made just for you · shipping details at checkout']
    ]);
  }

  function relabelColorChoice() {
    document.querySelectorAll('pet-portrait-configurator [data-ppc-role="color"]').forEach(function (group) {
      var label = group.querySelector('.ppc-label');
      if (!label) return;
      var values = [].slice.call(group.querySelectorAll('[data-ppc-val]')).map(function (el) {
        return String(el.getAttribute('data-ppc-val') || '').toLowerCase();
      }).join(' ');
      var heading = (values.indexOf('rot') !== -1 || values.indexOf('pink') !== -1) ? 'Color ' : 'Material ';
      var first = label.childNodes && label.childNodes[0];
      if (first && first.nodeType === Node.TEXT_NODE) first.nodeValue = heading;
    });
  }

  function marqueeSet(hidden) {
    var items = [
      '100-DAY ENGRAVING GUARANTEE',
      'YOUR PHOTO IS REVIEWED BEFORE PRODUCTION',
      'EACH PIECE · UNIQUELY PERSONALIZED',
      'YOUR PHOTO · YOUR CUSTOM ENGRAVING'
    ];
    var attrs = hidden ? ' aria-hidden="true"' : '';
    return '<div class="tsc-marquee__set"' + attrs + '>' + items.map(function (item) {
      return '<span class="tsc-marquee__item">' + item + '</span>';
    }).join('') + '</div>';
  }

  function upgradeHomeHero() {
    var home = document.querySelector('[data-tsc-home]') || document.querySelector('.tsc-home');
    if (!home) return;
    var hero = home.querySelector('.tsc-hero');
    if (!hero) return;
    hero.classList.add('tsc-hero--premium');

    var content = hero.querySelector('.tsc-hero__content');
    if (!content) return;

    var offer = content.querySelector('.tsc-hero__offer, .tsc-offer, .tsc-hero__eyebrow');
    if (offer) {
      offer.className = 'tsc-hero__eyebrow';
      offer.textContent = 'MADE PERSONAL FROM YOUR PET PHOTO';
    }

    var heading = content.querySelector('h1');
    if (heading) heading.textContent = 'Your Pet. Always Close to You.';

    var body = null;
    var paragraphs = content.querySelectorAll('p');
    for (var i = 0; i < paragraphs.length; i++) {
      if (!paragraphs[i].classList.contains('tsc-hero__eyebrow') && !paragraphs[i].classList.contains('tsc-hero__micro')) {
        body = paragraphs[i];
        break;
      }
    }
    if (body) body.textContent = 'Turn your favorite pet photo into meaningful jewelry that keeps your bond close.';

    var cta = content.querySelector('.tsc-button');
    if (cta) {
      cta.setAttribute('href', routeRoot() + 'products/personalized-pet-portrait-necklace');
      cta.textContent = 'PERSONALIZE YOURS';
      if (!content.querySelector('.tsc-hero__micro')) {
        var micro = document.createElement('p');
        micro.className = 'tsc-hero__micro';
        micro.textContent = 'Upload your photo · we review it before production';
        cta.insertAdjacentElement('afterend', micro);
      }
    }

    if (!home.querySelector('.tsc-marquee')) {
      var marquee = document.createElement('div');
      marquee.className = 'tsc-marquee';
      marquee.setAttribute('role', 'region');
      marquee.setAttribute('aria-label', 'PawToKeep benefits');
      marquee.innerHTML = '<div class="tsc-marquee__track">' + marqueeSet(false) + marqueeSet(true) + '</div>';
      hero.parentNode.insertBefore(marquee, hero.nextSibling);
    }
  }

  function addHidden(form, value) {
    var input = form.querySelector('input[data-ts-back-hidden="bundle"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.setAttribute('data-ts-back-hidden', 'bundle');
      form.appendChild(input);
    }
    input.name = BACK_FIELD;
    input.value = value;
  }

  function removeHidden(form) {
    var input = form && form.querySelector('input[data-ts-back-hidden="bundle"]');
    if (input) input.remove();
  }

  function updateBackCounter(box) {
    var text = box && box.querySelector('[data-ppc-back-text]');
    var count = box && box.querySelector('[data-ppc-back-count]');
    if (text && count) count.textContent = text.value.length + '/30';
  }

  function syncBackBox(box) {
    if (!box) return;
    var group = box.closest('[data-ppc-pet], [data-tsg-pet]');
    var check = box.querySelector('[data-ppc-back-check]');
    var field = box.querySelector('[data-ppc-back-field]');
    var text = box.querySelector('[data-ppc-back-text]');
    var error = box.querySelector('[data-ppc-back-error]');
    if (!group || !check || !field || !text) return;

    var activeGroup = !group.hidden;
    check.disabled = !activeGroup;
    text.disabled = !activeGroup || !check.checked;
    field.hidden = !check.checked;
    box.classList.toggle('is-active', activeGroup && check.checked);
    check.setAttribute('aria-expanded', check.checked ? 'true' : 'false');
    if (error && (!check.checked || text.value.trim())) error.textContent = '';
    updateBackCounter(box);
  }

  function syncBackGroups(form) {
    if (!form) return;
    form.querySelectorAll('[data-ppc-back]').forEach(syncBackBox);
  }

  function resetBackEngravingUi(form) {
    if (!form) return;
    form.querySelectorAll('[data-ppc-back]').forEach(function (box) {
      var check = box.querySelector('[data-ppc-back-check]');
      var field = box.querySelector('[data-ppc-back-field]');
      var text = box.querySelector('[data-ppc-back-text]');
      var error = box.querySelector('[data-ppc-back-error]');
      if (check) check.checked = false;
      if (text) { text.value = ''; text.disabled = true; }
      if (field) field.hidden = true;
      if (error) error.textContent = '';
      box.classList.remove('is-active');
      updateBackCounter(box);
    });
    removeHidden(form);
  }

  function bindBackBox(box) {
    if (!box || box.getAttribute('data-ts-back-bound') === 'true') return;
    box.setAttribute('data-ts-back-bound', 'true');
    var check = box.querySelector('[data-ppc-back-check]');
    var text = box.querySelector('[data-ppc-back-text]');
    if (check) check.addEventListener('change', function () { syncBackBox(box); });
    if (text) text.addEventListener('input', function () {
      if (text.value.length > 30) text.value = text.value.slice(0, 30);
      updateBackCounter(box);
      var error = box.querySelector('[data-ppc-back-error]');
      if (error && text.value.trim()) error.textContent = '';
    });
    syncBackBox(box);
  }

  function injectBackEngraving(root, handle) {
    var gift = !!root;
    if (ELIGIBLE_BACK_ENGRAVING.indexOf(gift ? handle : currentHandle()) === -1) {
      if (gift) root.querySelectorAll('[data-ppc-back]').forEach(function (box) { box.remove(); });
      return;
    }
    var selector = gift ? '[data-tsg-pet]' : '[data-ppc-pet]';
    var forms = gift ? [root] : document.querySelectorAll('pet-portrait-configurator form.ppc-form');
    forms.forEach(function (form) {
      form.querySelectorAll('.ts-back-engraving').forEach(function (old) { old.remove(); });
      var supportsMultiple = form.querySelectorAll(selector).length > 1;

      form.querySelectorAll(selector).forEach(function (group, index) {
        var box = group.querySelector('[data-ppc-back]');
        if (!box) {
          var petIndex = parseInt(group.getAttribute('data-ppc-pet'), 10) || (index + 1);
          var assignment = supportsMultiple ? ('For charm ' + petIndex) : 'For this charm';
          var destination = supportsMultiple ? ('Engraved on the back of charm ' + petIndex + '.') : 'Engraved on the back of this charm.';
          var fieldId = (gift ? 'tsg-back-field-' : 'ts-back-field-') + petIndex;
          var textId = (gift ? 'tsg-back-text-' : 'ts-back-text-') + petIndex;
          box = document.createElement('div');
          box.className = 'ppc-back';
          box.setAttribute('data-ppc-back', String(petIndex));
          box.innerHTML =
            '<label class="ppc-back__toggle">' +
              '<input class="ppc-back__native" type="checkbox" data-ppc-back-check aria-expanded="false" aria-controls="' + fieldId + '">' +
              '<span class="ppc-back__check" aria-hidden="true">' +
                '<svg viewBox="0 0 16 16" width="13" height="13"><path d="M3.2 8.2l3 3 6.6-6.7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              '</span>' +
              '<span class="ppc-back__copy">' +
                '<span class="ppc-back__titleline">' +
                  '<strong>Add a personal back engraving</strong>' +
                  '<span class="ppc-back__selected">SELECTED</span>' +
                '</span>' +
                '<small><span class="ppc-back__assignment">' + assignment + '</span> · Name, date or personal message</small>' +
              '</span>' +
              '<span class="ppc-back__price">' + BACK_PRICE + '</span>' +
            '</label>' +
            '<div class="ppc-back__field" id="' + fieldId + '" data-ppc-back-field hidden>' +
              '<span class="ppc-back__eyebrow">YOUR BACK ENGRAVING</span>' +
              '<label for="' + textId + '">What would you like engraved?</label>' +
              '<div class="ppc-back__input-wrap">' +
                '<input id="' + textId + '" type="text" data-ppc-back-text maxlength="30" disabled placeholder="e.g. Forever by my side ♡" autocomplete="off">' +
                '<span class="ppc-back__counter" data-ppc-back-count aria-hidden="true">0/30</span>' +
              '</div>' +
              '<small class="ppc-back__destination">Max. 30 characters · ' + destination + '</small>' +
              '<span class="ppc-back__examples">Examples: Laki · 2012–2026 · Forever by my side ♡</span>' +
            '</div>' +
            '<p class="ppc-back__error" data-ppc-back-error role="alert"></p>';

          var anchor = group.querySelector('[data-ppc-error]');
          if (anchor) group.insertBefore(box, anchor);
          else group.appendChild(box);
        }
        bindBackBox(box);
      });

      syncBackGroups(form);
    });
  }

  window.TreuespurBackEngraving = {
    mount: injectBackEngraving,
    sync: syncBackGroups,
    reset: resetBackEngravingUi,
    collect: function (root) {
      var backs = [];
      root.querySelectorAll('[data-tsg-pet]').forEach(function (group, index) {
        if (group.hidden) return;
        var check = group.querySelector('[data-ppc-back-check]');
        var text = group.querySelector('[data-ppc-back-text]');
        if (check && !check.disabled && check.checked && text) {
          backs.push({ index: index + 1, text: text.value.trim() });
        }
      });
      return backs;
    }
  };

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var option = event.target.closest('pet-portrait-configurator [data-ppc-val]');
    if (!option) return;
    var form = option.closest('form.ppc-form');
    window.setTimeout(function () { syncBackGroups(form); }, 0);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('pet-portrait-configurator form.ppc-form');
    if (!form || !form.querySelector('[data-ppc-back]')) return;

    syncBackGroups(form);
    var backs = [];
    var invalid = null;

    form.querySelectorAll('[data-ppc-pet]').forEach(function (group, index) {
      if (group.hidden || invalid) return;
      var box = group.querySelector('[data-ppc-back]');
      if (!box) return;
      var check = box.querySelector('[data-ppc-back-check]');
      var text = box.querySelector('[data-ppc-back-text]');
      var error = box.querySelector('[data-ppc-back-error]');
      if (!check || !check.checked) return;
      var value = (text.value || '').trim();
      if (!value) {
        invalid = text;
        if (error) error.textContent = 'Please enter your text for the back engraving.';
        return;
      }
      var petIndex = parseInt(group.getAttribute('data-ppc-pet'), 10) || (index + 1);
      backs.push({ index: petIndex, text: value });
    });

    if (invalid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      invalid.disabled = false;
      invalid.focus();
      return;
    }

    if (backs.length) addHidden(form, JSON.stringify(backs));
    else removeHidden(form);
  }, true);

  function jsonErrorResponse(message, status) {
    return new Response(JSON.stringify({ description: message }), {
      status: status || 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  var nativeFetch = window.fetch.bind(window);
  var boxConfig = window.TSBoxConfig;
  var cartQueue = Promise.resolve();
  var cartPending = 0;
  var cartReady = false;
  var cartFailed = false;
  var cartError = 'Your cart could not be fully updated. Please check your selection and try again.';
  function cartState() {
    return { busy: cartPending > 0, ready: cartReady, error: cartFailed };
  }
  function publishCartState() {
    if (document.dispatchEvent && typeof CustomEvent === 'function') {
      document.dispatchEvent(new CustomEvent('ptk:cart-state', { detail: cartState() }));
    }
  }
  function enqueueCart(task) {
    cartPending += 1;
    publishCartState();
    var result = cartQueue.then(task, task).then(function (value) {
      cartReady = !(value && value.ok === false);
      cartFailed = !cartReady;
      return value;
    }, function (error) {
      cartReady = false;
      cartFailed = true;
      throw error;
    }).finally(function () {
      cartPending -= 1;
      publishCartState();
    });
    cartQueue = result.catch(function () {});
    return result;
  }
  function cartRequest(path, payload) {
    var options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (payload) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(payload);
    }
    return nativeFetch(routeRoot() + path + (payload ? '' : (path.indexOf('?') === -1 ? '?' : '&') + '_ts_box=' + Date.now() + Math.random().toString(36).slice(2)), options).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) {
          var problem = new Error(body.description || cartError);
          problem.httpStatus = response.status;
          throw problem;
        }
        return body;
      });
    });
  }
  function eligibleParent(item) {
    return boxConfig && (boxConfig.handles.indexOf(item.handle) !== -1 || !!(item.properties || {})._treuespur_back_spec) && !(item.properties || {})._treuespur_addon;
  }
  function parentMatches(child, parents) {
    var props = child.properties || {};
    var relationship = child.parent_relationship || {};
    var nativeKey = (relationship.parent && relationship.parent.key) || relationship.parent_key;
    var bestPriority = 0, matches = [];
    parents.forEach(function (parent) {
      var own = parent.properties || {};
      var priority = nativeKey && nativeKey === parent.key ? 4 :
        props._treuespur_parent_group && props._treuespur_parent_group === own._treuespur_box_group ? 3 :
        props._treuespur_parent_key && props._treuespur_parent_key === parent.key ? 2 :
        props._treuespur_bogo_group && own._treuespur_bogo_group === props._treuespur_bogo_group ? 1 : 0;
      if (priority > bestPriority) { bestPriority = priority; matches = [parent]; }
      else if (priority && priority === bestPriority) matches.push(parent);
    });
    // Shopify can split one parent into separate cart lines with the same
    // personalization group. Only an exact key inside that group may break
    // this tie; an explicit key in another group must never override it.
    if (bestPriority === 3 && matches.length > 1 && props._treuespur_parent_key) {
      var exact = matches.filter(function (parent) { return parent.key === props._treuespur_parent_key; });
      if (exact.length === 1) return exact;
    }
    return matches;
  }
  function parentOf(child, parents) {
    var matches = parentMatches(child, parents);
    return matches.length === 1 ? matches[0] : null;
  }
  function backSpecs(parent) {
    try {
      var specs = JSON.parse((parent.properties || {})._treuespur_back_spec || '[]');
      if (!Array.isArray(specs)) throw new Error(cartError);
      return specs;
    }
    catch (error) { throw new Error(cartError); }
  }
  function backIndex(back) {
    var props = back.properties || {};
    return String(props._treuespur_back_index || props['For pendant'] || props['Für Anhänger'] || String(props.Zuordnung || '').replace('Anhänger ', ''));
  }
  function removeBackSelection(payload, requestedSections) {
    return cartRequest('cart.js').then(function (cart) {
      var child = payload.id != null ? cart.items.find(function (item) { return item.key === String(payload.id); }) ||
        cart.items.find(function (item) { return String(item.variant_id) === String(payload.id); }) : cart.items[Number(payload.line) - 1];
      if (!child || (child.properties || {})._treuespur_addon !== 'back-engraving') return null;
      var owners = parentMatches(child, cart.items.filter(eligibleParent));
      if (owners.length > 1) throw new Error(cartError);
      var parent = owners.length === 1 ? owners[0] : null;
      // Legacy engravings without a saved selection can use the normal removal.
      if (!parent || !(parent.properties || {})._treuespur_back_spec) return null;
      var specs = backSpecs(parent);
      var remaining = specs.filter(function (spec) { return String(spec.index) !== backIndex(child); });
      if (remaining.length === specs.length) return null;
      // Shopify changes the line key when properties change. Preserve every
      // property (including uploaded photos), then resolve child keys afresh.
      var properties = Object.assign({}, parent.properties, { _treuespur_back_spec: JSON.stringify(remaining) });
      return cartRequest('cart/change.js', { id: parent.key, quantity: parent.quantity, properties: properties }).then(function () {
        return reconcileCart(0);
      }).then(function (updated) { return sectionResult(updated, null, requestedSections); });
    });
  }

  var PTK_GIFT_VARIANTS = { gold: 55520360759633, silver: 55520360792401, box: 55520360890705 };
  function giftEligibleParent(item) {
    var handles = boxConfig && boxConfig.giftHandles || ['regenbogenbruecke-kette-tierportraet'];
    return handles.indexOf(item.handle) !== -1 && !(item.properties || {})._treuespur_addon;
  }
  function reconcileIncludedGifts(cart, updates, additions) {
    var parents = cart.items.filter(giftEligibleParent);
    var gifts = cart.items.filter(function (item) {
      return Object.values(PTK_GIFT_VARIANTS).includes(Number(item.variant_id)) &&
        ['sale-gift-keychain', 'sale-gift-box'].includes((item.properties || {})._treuespur_addon);
    });
    function owner(gift) {
      var props = gift.properties || {};
      var linkedGift = Object.assign({}, gift, { properties: Object.assign({}, props, {
        _treuespur_parent_key: props._ptk_parent_key || props._treuespur_parent_key
      }) });
      var matches = parentMatches(linkedGift, parents);
      if (matches.length > 1) throw new Error(cartError);
      return matches.length === 1 ? matches[0] : null;
    }
    function linkPriority(gift, parent) {
      var relationship = gift.parent_relationship || {};
      var nativeKey = relationship.parent && relationship.parent.key || relationship.parent_key;
      if (nativeKey === parent.key) return 3;
      if ((gift.properties || {})._ptk_parent_key === parent.key) return 2;
      return 1;
    }
    gifts.forEach(function (gift) {
      if ((gift.properties || {})._treuespur_addon === 'sale-gift-keychain' || !owner(gift)) {
        updates[gift.key] = 0;
      }
    });
    parents.forEach(function (parent) {
      var matches = gifts.filter(function (gift) {
        return owner(gift) === parent && Number(gift.variant_id) === PTK_GIFT_VARIANTS.box;
      });
      // After removing a split parent, retain the remaining native attachment
      // rather than an old unbound gift that only matches the shared group.
      matches.sort(function (a, b) { return linkPriority(b, parent) - linkPriority(a, parent); });
      matches.slice(1).forEach(function (gift) { updates[gift.key] = 0; });
      if (matches.length) {
        if (matches[0].quantity !== parent.quantity) updates[matches[0].key] = parent.quantity;
        return;
      }
      var properties = {
        _treuespur_addon: 'sale-gift-box', _treuespur_bogo_exclude: 'true', _ptk_parent_key: parent.key,
        _treuespur_parent_group: (parent.properties || {})._treuespur_box_group || parent.key,
        'Gift for': parent.product_title || parent.title || parent.handle
      };
      additions.push({ id: PTK_GIFT_VARIANTS.box, quantity: parent.quantity, parent_line_key: parent.key, properties: properties });
    });
  }

  function reconcileCart(pass) {
    return cartRequest('cart.js').then(function (cart) {
      if (!boxConfig) return cart;
      var parents = cart.items.filter(eligibleParent);
      var updates = {}, additions = [];
      reconcileIncludedGifts(cart, updates, additions);
      // Do not insert, discount-check or retain automatically attached gift boxes.
      // Only remove old auto-gift lines, never a jewellery box explicitly purchased.
      var oldGiftBoxes = cart.items.filter(function (item) {
        return Number(item.variant_id) === boxConfig.variantId &&
          (item.properties || {})._treuespur_addon === 'gift-box';
      });
      var backs = cart.items.filter(function (item) { return (item.properties || {})._treuespur_addon === 'back-engraving'; });
      // Ambiguous legacy BOGO ownership is not an orphan. Never delete a paid
      // line or edit a parent's saved selection based on an arbitrary match.
      if (backs.some(function (back) { return parentMatches(back, parents).length > 1; })) throw new Error(cartError);
      oldGiftBoxes.forEach(function (item) { updates[item.key] = 0; });
      backs.forEach(function (child) {
        if (!parentOf(child, parents)) updates[child.key] = 0;
      });
      parents.forEach(function (parent) {
        var parentProps = parent.properties || {};
        var group = parentProps._treuespur_box_group || parentProps._treuespur_bogo_group || parent.key;
        var ownedBacks = backs.filter(function (back) { return parentOf(back, parents) === parent; });
        var specs = backSpecs(parent);
        ownedBacks.forEach(function (back) {
          // A persisted selection is authoritative. This also completes an
          // interrupted removal without recreating a paid engraving at checkout.
          if (parentProps._treuespur_back_spec && !specs.some(function (spec) { return String(spec.index) === backIndex(back); })) updates[back.key] = 0;
          else if (back.quantity !== parent.quantity) updates[back.key] = parent.quantity;
        });
        specs.forEach(function (spec) {
          var matches = ownedBacks.filter(function (back) {
            return backIndex(back) === String(spec.index);
          });
          matches.slice(1).forEach(function (back) { updates[back.key] = 0; });
          if (!matches.length) {
            var properties = {
              'For pendant': String(spec.index), 'Personal message': spec.text || [spec.line1, spec.line2].filter(Boolean).join('\n'),
              _treuespur_addon: 'back-engraving', _treuespur_bogo_exclude: 'true', _treuespur_parent_group: group,
              _treuespur_bogo_group: parentProps._treuespur_bogo_group || group, _treuespur_back_index: String(spec.index), _treuespur_font: '22'
            };
            if (spec.line1) properties['Line 1'] = spec.line1;
            if (spec.line2) properties['Line 2'] = spec.line2;
            additions.push({ id: BACK_ADDON_VARIANT, quantity: parent.quantity, parent_line_key: parent.key, properties: properties });
          }
        });
      });
      if (Object.keys(updates).length || additions.length) {
        if (pass >= 3) throw new Error(cartError);
        var operation = Object.keys(updates).length ? cartRequest('cart/update.js', { updates: updates }) : cartRequest('cart/add.js', { items: additions });
        return operation.catch(function (error) {
          // Retry only uncertain transport failures; a Shopify 4xx response is
          // a definite rejection and must not trigger several more requests.
          if (error && error.httpStatus >= 400 && error.httpStatus < 500) throw error;
        }).then(function () { return reconcileCart(pass + 1); });
      }
      return cart;
    });
  }
  function sectionResult(cart, base, requested) {
    var sectionIds = ['treuespur-cart-drawer'];
    var requestedIds = Array.isArray(requested) ? requested : String(requested || '').split(',');
    var refreshCartPage = false;
    // Automatic gift reconciliation must refresh the native cart as well as
    // the drawer. Explicit native quantity requests already apply their section.
    if (document.querySelectorAll) document.querySelectorAll('#MainContent cart-items-component[data-section-id]').forEach(function (component) {
      var id = component.dataset.sectionId;
      if (id && sectionIds.indexOf(id) === -1 && sectionIds.length < 5) sectionIds.push(id);
      if (id && requestedIds.indexOf(id) === -1) refreshCartPage = true;
    });
    requestedIds.forEach(function (id) {
      if (id && sectionIds.indexOf(id) === -1 && sectionIds.length < 5) sectionIds.push(id);
    });
    return cartRequest('cart/update.js', { updates: {}, sections: sectionIds.join(','), sections_url: window.location.pathname }).then(function (fresh) {
      var sections = fresh.sections;
      cart = fresh;
      var result = base || cart;
      result.sections = sections;
      result.item_count = cart.item_count;
      if (window.TSG) {
        window.TSG.applySections(result);
        window.TSG.setBubble(cart.item_count);
      }
      if (refreshCartPage) document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
        resource: cart, sourceId: 'treuespur-boxes-sync', data: { itemCount: cart.item_count, source: 'treuespur-boxes-sync', sections: sections }
      } }));
      return result;
    });
  }
  function displayCartError(error) {
    var foot = document.querySelector('#ts-drawer .ts-dw__foot') || document.querySelector('#ts-drawer .ts-dw__body');
    if (!foot) return;
    var message = foot.querySelector('[data-ts-box-error]');
    if (!message) { message = document.createElement('p'); message.setAttribute('data-ts-box-error', ''); message.setAttribute('role', 'alert'); foot.prepend(message); }
    message.textContent = error.message || cartError;
  }
  function makeGroup() {
    return window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
  }
  function prepareMain(properties, group) {
    properties = properties || {};
    var raw = properties._treuespur_back_engravings;
    delete properties._treuespur_back_engravings;
    properties._treuespur_box_group = group;
    properties._treuespur_bogo_group = group;
    if (raw) properties._treuespur_back_spec = typeof raw === 'string' ? raw : JSON.stringify(raw);
    return properties;
  }
  function mutateCart(input, init, kind) {
    var options = Object.assign({}, init), body = options.body, payload, groups = [], requestedSections;
    if (body instanceof FormData) {
      var form = new FormData();
      body.forEach(function (value, key) { form.append(key, value); });
      if (kind === 'add' && ![BACK_ADDON_VARIANT, boxConfig.variantId].includes(Number(form.get('id')))) {
        var group = makeGroup(); groups.push(group);
        var props = prepareMain({ _treuespur_back_engravings: form.get(BACK_FIELD) }, group);
        form.delete(BACK_FIELD);
        Object.keys(props).forEach(function (key) { form.set('properties[' + key + ']', props[key]); });
      }
      requestedSections = form.get('sections');
      options.body = form;
    } else {
      try { payload = typeof body === 'string' ? JSON.parse(body) : null; } catch (error) { payload = null; }
      requestedSections = payload && payload.sections;
      if (kind === 'add' && payload) {
        (payload.items || [payload]).forEach(function (item) {
          if ([BACK_ADDON_VARIANT, boxConfig.variantId].includes(Number(item.id))) return;
          var group = makeGroup(); groups.push(group);
          item.properties = prepareMain(item.properties, group);
        });
        options.body = JSON.stringify(payload);
      }
    }
    var removalPayload = payload || (body instanceof FormData ? { id: body.get('id'), line: body.get('line'), quantity: body.get('quantity') } : null);
    var removal = kind === 'change' && removalPayload && removalPayload.quantity != null && Number(removalPayload.quantity) === 0 ?
      removeBackSelection(removalPayload, requestedSections) : Promise.resolve(null);
    return removal.then(function (removed) {
      if (removed) return new Response(JSON.stringify(removed), { status: 200, headers: { 'Content-Type': 'application/json' } });
      return nativeFetch(input, options).then(function (response) {
      if (!response.ok) {
        return reconcileCart(0).catch(function () {}).then(function () { return response; });
      }
      return response.clone().json().then(function (base) {
        // Use the drawer section Shopify already rendered in the *same* upload
        // request. Skips two extra round trips in the standard no-addon case.
        // Never skip reconciliation for paid back engraving or stale gift boxes.
        var section = base && base.sections && base.sections['treuespur-cart-drawer'];
        var needsBack = kind === 'add' && (
          (body instanceof FormData && !!body.get(BACK_FIELD)) ||
          (payload && (payload.items || [payload]).some(function (item) {
            var p = item.properties || {};
            return !!(p._treuespur_back_engravings || p._treuespur_back_spec);
          }))
        );
        var validSection = typeof section === 'string' && section.indexOf('id="ts-drawer"') !== -1;
        var oldGiftInDrawer = validSection && section.indexOf('ts-box-line') !== -1;
        var hasIncludedGifts = validSection && (section.indexOf('data-ptk-included-gift') !== -1 || section.indexOf('data-ptk-rainbow-gifts') !== -1);
        // A confirmed cart/change.js response already contains the updated
        // drawer. Don't queue two more round-trips just to remove one item.
        // Existing paid reverse-engraving lines require reconciliation so
        // that orphaned paid lines are never charged after a parent is deleted.
        var hasPaidAddon = validSection && section.indexOf('data-ts-addon="back-engraving"') !== -1;
        if (kind === 'change' && payload && Number(payload.quantity) === 0 &&
            validSection && !oldGiftInDrawer && !hasPaidAddon && !hasIncludedGifts) {
          return new Response(JSON.stringify(base), { status: 200, headers: { 'Content-Type': 'application/json' } });
        }
        if (kind === 'add' && groups.length && validSection && !needsBack && !oldGiftInDrawer && !hasIncludedGifts) {
          return new Response(JSON.stringify(base), { status: 200, headers: { 'Content-Type': 'application/json' } });
        }
        function fallbackCart() {
          return reconcileCart(0).then(function (cart) { return sectionResult(cart, kind === 'add' ? base : null, requestedSections); }).then(function (result) {
            return new Response(JSON.stringify(result), { status: 200, headers: { 'Content-Type': 'application/json' } });
          });
        }

        // Paid reverse engraving: when Shopify confirms the main photo upload
        // and has already rendered its drawer, add all reverse sides together
        // in one second POST that also returns the complete drawer. No GET
        // cart.js or cart/update.js on the verified happy path.
        if (kind === 'add' && groups.length && needsBack && validSection && !oldGiftInDrawer && !hasIncludedGifts && base && base.key) {
          var originalSpecs = body instanceof FormData ? body.get(BACK_FIELD) : null;
          if (!originalSpecs && payload) {
            var requested = payload.items || [payload];
            originalSpecs = requested.length === 1 && requested[0].properties &&
              (requested[0].properties._treuespur_back_engravings || requested[0].properties._treuespur_back_spec);
          }
          var specs = null;
          try {
            specs = typeof originalSpecs === 'string' ? JSON.parse(originalSpecs) : originalSpecs;
          } catch (error) { specs = null; }

          if (Array.isArray(specs) && specs.length && specs.every(function (spec) {
            return spec && Number(spec.index) >= 1 && (spec.text || spec.line1 || spec.line2);
          })) {
            var properties = base.properties || {};
            var group = properties._treuespur_box_group || groups[0];
            var paidItems = specs.map(function (spec) {
              var itemProperties = {
                'For pendant': String(spec.index),
                'Personal message': spec.text || [spec.line1, spec.line2].filter(Boolean).join('\n'),
                _treuespur_addon: 'back-engraving',
                _treuespur_bogo_exclude: 'true',
                _treuespur_parent_group: group,
                _treuespur_bogo_group: properties._treuespur_bogo_group || group,
                _treuespur_back_index: String(spec.index),
                _treuespur_font: '22'
              };
              if (spec.line1) itemProperties['Line 1'] = spec.line1;
              if (spec.line2) itemProperties['Line 2'] = spec.line2;
              return { id: BACK_ADDON_VARIANT, quantity: Number(base.quantity) || 1, parent_line_key: base.key, properties: itemProperties };
            });
            return cartRequest('cart/add.js', {
              items: paidItems,
              sections: 'treuespur-cart-drawer',
              sections_url: window.location.pathname
            }).then(function (added) {
              var html = added && added.sections && added.sections['treuespur-cart-drawer'];
              var returned = added && added.items;
              var rendered = typeof html === 'string' && html.indexOf('id="ts-drawer"') !== -1 &&
                html.indexOf('ts-box-line') === -1;
              var allAdded = Array.isArray(returned) && returned.length === paidItems.length &&
                returned.every(function (item) { return Number(item.variant_id) === BACK_ADDON_VARIANT; });
              if (!rendered || !allAdded) return fallbackCart();
              base.sections = added.sections;
              return new Response(JSON.stringify(base), { status: 200, headers: { 'Content-Type': 'application/json' } });
            }, function () { return fallbackCart(); });
          }
        }
        return fallbackCart();
      });
    }, function (error) {
      return cartRequest('cart.js').then(function (cart) {
        var confirmed = groups.length && groups.every(function (group) {
          return cart.items.some(function (item) { return (item.properties || {})._treuespur_box_group === group; });
        });
        if (!confirmed) throw error;
        var main = cart.items.find(function (item) { return (item.properties || {})._treuespur_box_group === groups[0]; });
        return reconcileCart(0).then(function (updated) { return sectionResult(updated, main, requestedSections); }).then(function (result) {
          return new Response(JSON.stringify(result), { status: 200, headers: { 'Content-Type': 'application/json' } });
        });
      });
      });
    });
  }
  if (boxConfig) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var kind = /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.exec(url);
      if (!kind || !(init && init.body) || String(init.method || 'GET').toUpperCase() !== 'POST') return nativeFetch(input, init);
      return enqueueCart(function () { return mutateCart(input, init, kind[1]); }).catch(function (error) {
        return jsonErrorResponse(error.message || cartError, 422);
      });
    };
    window.TreuespurBoxes = {
      getState: cartState,
      sync: function () { return enqueueCart(function () { return reconcileCart(0).then(function (cart) { return sectionResult(cart); }); }); }
    };
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[action*="/cart"]')) return;
      if (!form.matches('.ts-checkout-form') && !(event.submitter && event.submitter.name === 'checkout')) return;
      event.preventDefault(); event.stopImmediatePropagation();
      var button = event.submitter;
      if (button) button.disabled = true;
      window.TreuespurBoxes.sync().then(function () { window.location.assign(routeRoot() + 'checkout'); }).catch(function (error) {
        displayCartError(error); if (button) button.disabled = false;
      });
    }, true);
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-ts-box-quantity]');
      if (!button) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (button.disabled) return;
      button.disabled = true;
      var controls = button.closest('.ts-box-quantity');
      if (controls) controls.querySelectorAll('button').forEach(function (control) { control.disabled = true; });
      window.fetch(routeRoot() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: button.dataset.tsBoxKey, quantity: Number(button.dataset.tsBoxQuantity), sections: 'treuespur-cart-drawer', sections_url: routeRoot() + 'cart' })
      }).then(function (response) { return response.json().then(function (result) {
        if (!response.ok) throw new Error(result.description || cartError);
        if (window.TSG) { window.TSG.applySections(result); window.TSG.setBubble(result.item_count); }
      }); }).catch(displayCartError).finally(function () {
        if (controls && document.contains(controls)) controls.querySelectorAll('button').forEach(function (control) { control.disabled = false; });
      });
    }, true);
    // Photo-picker returns and page revisits must never queue two extra
    // cart requests ahead of the product add-to-cart flow.
    // Checkout and cart-update actions still perform their own reconciliation.
    window.addEventListener('pageshow', function () {
      if (!currentHandle() || currentHandle() === 'regenbogenbruecke-kette-tierportraet') window.TreuespurBoxes.sync().catch(displayCartError);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && !currentHandle()) {
        window.TreuespurBoxes.sync().catch(displayCartError);
      }
    });
  }

  function normalizeNameLimitCopy() {
    var root = document.querySelector('main');
    if (!root || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue || !/(acht Zeichen|8 Zeichen)/i.test(node.nodeValue)) continue;
      node.nodeValue = node.nodeValue
        .replace(/acht Zeichen/gi, 'neun Zeichen')
        .replace(/8 Zeichen/g, '9 Zeichen');
    }
  }

  function refresh() {
    normalizeAnnouncements();
    relabelColorChoice();
    injectBackEngraving();
    normalizeNameLimitCopy();
  }

  function init() {
    refresh();
    window.setTimeout(refresh, 450);
    window.setTimeout(refresh, 1200);
  }

  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();


